import React from 'react'
import { Route, Routes } from 'react-router'
import AdminLandingPage from '../app/admin/dashboard/pages/AdminLandingPage'
import BarcodeManagerPage from '../app/admin/barcode/pages/PrintBarcodePage'

import ManageDocumentPage from '../app/admin/document/pages/ManageDocumentPage'
import DocumentDetailsPage from '../app/admin/document/pages/DocumentDetailsPage'
import BarcodeSearchPage from '../app/admin/barcode/pages/BarcodeSearchPage'

import PODashboardPage from '../app/admin/erp/po/pages/PODashboardPage'

import POTermsPage from '../app/admin/erp/po/pages/POTermsPage'
import VendorDashboard from '../app/admin/erp/vendors/pages/VendorDashboard'
import VendorListpage from '../app/admin/erp/vendors/pages/VendorListpage'
import InventoryDashboarPage from '../app/admin/erp/inventory/pages/InventoryDashboarPage'
import InventoryListPage from '../app/admin/erp/inventory/pages/InventoryListPage'
import ProductDashboardPage from '../app/admin/erp/product/pages/ProductDashboardPage'
import ProductListPage from '../app/admin/erp/product/pages/ProductListPage'
import ProjectLocationDashboard from '../app/admin/erp/project/pages/ProjectLocationDashboard'
import ProjectDashboardPage from '../app/admin/erp/project/pages/ProjectDashboardPage'
import CustomerDashboardPage from '../app/admin/erp/customer/pages/CustomerDashboardPage'
import CompanyDashboardPage from '../app/admin/erp/company/pages/ComapnyDashboardPage'
import PODetailsPage from '../app/admin/erp/po/pages/PODetailsPage'
import ProjectDetailsPage from '../app/admin/erp/project/pages/ProjectDetailsPage'
import TransactionDashboardPage from '../app/admin/erp/transaction/pages/TransactionDashboardPage'
import TransactionCategoryDashboard from '../app/admin/erp/transaction/pages/TransectionCategoryDashboard'
import EmployeeDashboardPage from '../app/admin/erp/employee/pages/EmployeeDashboardPage'
import TaskDashboardPage from '../app/admin/erp/tasks/pages/TaskDashboardPage'
import TaskListPage from '../app/admin/erp/tasks/pages/TaskListPage'
import TransactionListPage from '../app/admin/erp/transaction/pages/TransactionListPage'
import TransactionItemListPage from '../app/admin/erp/transaction/pages/TransactionItemListPage'
import ProjectTransactionPage from '../app/admin/erp/project/pages/ProjectTransactionPage'
import ProjectActivityPage from '../app/admin/erp/project/pages/ProjectActivityPage'
import ProjectTeamListPage from '../app/admin/erp/project/pages/ProjectTeamListPage'
import ProjectTeamDetailsPage from '../app/admin/erp/project/pages/ProjectTeamDetailsPage'
import ProjectTaskListPage from '../app/admin/erp/project/pages/ProjectTaskListPage'
import NotesReportPage from '../app/admin/erp/reports/pages/NotesReportPage'
import AttendanceDashboardPage from '../app/admin/erp/Attendance/pages/AttendanceDashboardPage'
import LeaveRequestDashboardPage from '../app/admin/erp/Attendance/pages/LeaveRequestDashboardPage'
import WorkReportDashboardPage from '../app/admin/erp/Attendance/pages/WorkReportDashboardPage'
import HolidayListPage from '../app/admin/erp/Attendance/pages/HolidayListPage'
import EmployeeAttendancePage from '../app/admin/erp/Attendance/pages/EmployeeAttendancePage'
import TenderDashboardPage from '../app/admin/erp/tender/pages/TenderDashboardPage'
import GrievanceDashboardPage from '../app/admin/erp/grievance/pages/GrievanceDashboardPage'
import EmployeeDetailsPage from '../app/admin/erp/employee/pages/EmployeeDetailsPage'
import EmployeePrintIdCardPage from '../app/admin/erp/employee/pages/EmployeeIdPrintCardPage'
import GrievanceDetailsPage from '../app/admin/erp/grievance/pages/GrievanceDetailsPage'
import InvoiceDashboardPage from '../app/admin/erp/invoice/pages/InvoiceDashboardPage'
import InvoiceDetailsPage from '../app/admin/erp/invoice/pages/InvoiceDetailsPage'
import CustomerDetailsPage from '../app/admin/erp/customer/pages/CustomerDetailsPage'
import TenderDetailsPage from '../app/admin/erp/tender/pages/TenderDetailsPage'
import CalendarEventListPage from '../app/admin/erp/calendar/pages/CalendarEventListPage'
import CalendarDashboardPage from '../app/admin/erp/calendar/pages/CalendarDashboardPage'



function ManagerRoutes() {
  return (
    <>
      <Routes>
        {/* Admin */}
        <Route path="/" element={ <AdminLandingPage /> }></Route>
        <Route path="/barcode/search" element={ <BarcodeSearchPage /> }></Route>
        <Route path="/barcode/manager" element={ <BarcodeManagerPage /> }></Route>
        <Route path="/document/dashboard" element={ <ManageDocumentPage /> }></Route>
        <Route path="/document/manager" element={ <ManageDocumentPage /> }></Route>
        <Route path="/document/details/:id" element={<DocumentDetailsPage /> }></Route>



        {/* ERP Pages */}

        <Route path="/po/terms" element={<POTermsPage/> }></Route>
        <Route path="/po/dashboard" element={<PODashboardPage/> }></Route>
        <Route path="/po/details/:id" element={<PODetailsPage/> }></Route>
        


        <Route path="/vendor/dashboard" element={<VendorDashboard/> }></Route>
        <Route path="/vendor/list" element={<VendorListpage/> }></Route>

        <Route path="/inventory/dashboard" element={<InventoryDashboarPage/> }></Route>
        <Route path="/inventory/list" element={<InventoryListPage/> }></Route>

        <Route path="/product/dashboard" element={<ProductDashboardPage/> }></Route>
        <Route path="/product/list" element={<ProductListPage/> }></Route>

        <Route path="/customer/dashboard" element={<CustomerDashboardPage /> }></Route>
        <Route path="/customer/details/:id" element={<CustomerDetailsPage /> }></Route>
        
        
        <Route path="/company/dashboard" element={<CompanyDashboardPage /> }></Route>
        <Route path="/employee/dashboard" element={<EmployeeDashboardPage /> }></Route>
        <Route path="/employee/details/:id" element={<EmployeeDetailsPage /> }></Route>
        <Route path="/employee/print-id-card" element={<EmployeePrintIdCardPage /> }></Route>


        <Route path="/project/dashboard" element={<ProjectDashboardPage /> }></Route>
        <Route path="/project/details/:id" element={<ProjectDetailsPage /> }></Route>
        
        <Route path="/project/task/:id" element={<ProjectTaskListPage /> }></Route>
        <Route path="/project/team-list/:id" element={<ProjectTeamListPage /> }></Route>
        <Route path="/project/team-details/:id" element={<ProjectTeamDetailsPage /> }></Route>
        <Route path="/project/transaction/:id" element={<ProjectTransactionPage /> }></Route>
        <Route path="/project/activity/:id" element={<ProjectActivityPage /> }></Route>

        <Route path="/project-location/dashboard" element={<ProjectLocationDashboard /> }></Route>
        
        

        <Route path="/task/dashboard" element={<TaskDashboardPage /> }></Route>
        <Route path="/task/list" element={<TaskListPage /> }></Route>

        <Route path="/transaction/dashboard" element={<TransactionDashboardPage /> }></Route>
        <Route path="/transaction/list" element={<TransactionListPage /> }></Route>
        <Route path="/transaction/item-list" element={<TransactionItemListPage /> }></Route>
        <Route path="/transaction-category/dashboard" element={<TransactionCategoryDashboard /> }></Route>


        <Route path="/attendance/dashboard" element={<AttendanceDashboardPage /> }></Route>
        <Route path="/attendance/employee/:id" element={<EmployeeAttendancePage /> }></Route>

        <Route path="/leave-request/dashboard" element={<LeaveRequestDashboardPage /> }></Route>
        <Route path="/work-report/dashboard" element={<WorkReportDashboardPage /> }></Route>
        <Route path="/holiday-list/dashboard" element={<HolidayListPage /> }></Route>



        <Route path="/report/notes" element={<NotesReportPage /> }></Route>



        <Route path="/tender/dashboard" element={<TenderDashboardPage /> }></Route>
        <Route path="/tender/details/:id" element={<TenderDetailsPage /> }></Route>
        

        <Route path="/grievance/dashboard" element={<GrievanceDashboardPage /> }></Route>
        <Route path="/grievance/details/:id" element={<GrievanceDetailsPage /> }></Route>


        <Route path="/invoice/dashboard" element={<InvoiceDashboardPage /> }></Route>
        <Route path="/invoice/details/:id" element={<InvoiceDetailsPage /> }></Route>

        <Route path="/calendar/dashboard" element={<CalendarDashboardPage /> }></Route>
        <Route path="/calendar/list" element={<CalendarEventListPage /> }></Route>
        

      </Routes>
    </>
  )
}

export default ManagerRoutes